// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__3503Z","avatar":"styles_avatar__19JNT","more":"styles_more__s4YQf"};